import { Job } from "../models/job";

export const groupStorageBoxOrders = (jobs: Job[]): Job[] => {
  const mapJobs: Map<number | undefined, Job> = new Map<number | undefined, Job>();

  jobs.forEach((job) => mapJobs.set(job.id, job));

  return Array.from(mapJobs.values()).sort((a, b) => {
    return (a.reference || "").localeCompare(b.reference || "");
  });
};
